export const versions = {
  version: "1.0.183",
  revision: "95d546bf7",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5056-g95d546bf7-dirty",
    hash: "g95d546bf7",
    distance: 5056,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5056-g95d546bf7-dirty",
    semverString: "1.0.183+5056.g95d546bf7.dirty"
  }
};
